import { connect } from 'react-redux';
import { addShoppableLookToCart } from 'arts/actions/cart_items';
import Items from './items';

export default connect(null, { addShoppableLookToCart })(Items);
